import { Filter } from "@/types/order-table";
import { Metrics } from "@/contexts/metrics-context";
import { Orders } from "@/contexts/orders-context";
import AdvanceFilterWLimit from "./presentational";

interface Props {
  type: Filter;
  useContext: () => Metrics | Orders;
}

const AdvanceFilterWLimitContainer = ({ type, useContext }: Props) => {
  return <AdvanceFilterWLimit type={type} useContext={useContext} />;
};

export default AdvanceFilterWLimitContainer;
